function GetApp() {
    return <h1>Get App</h1>;
}

export default GetApp;